import { IconType } from "./models/domain";
import { Icon } from "./components/icon";

export { IconType, Icon };
